import { useQuery } from "@tanstack/react-query";
import axiosAPI from "../axiosAPI";

const emptyKpis = {
  to_receive: 0,
  received: 0,
  expenses: 0,
  net_profit: 0,
  overdue_clients_count: 0,
  upcoming_dues_count: 0,
  upcoming_dues_amount: 0,
};

export const useFinancialDashboard = ({ month, year } = {}) => {
  const query = useQuery({
    queryKey: ["financial", "dashboard", month, year],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (month != null) params.set("month", String(month));
      if (year != null) params.set("year", String(year));
      const qs = params.toString();
      const { data } = await axiosAPI.get(
        `/financial/dashboard${qs ? `?${qs}` : ""}`
      );
      return data;
    },
  });

  return {
    kpis: query.data?.kpis ?? emptyKpis,
    month: query.data?.month ?? month,
    year: query.data?.year ?? year,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.error,
    refetch: query.refetch,
  };
};

export const useFinancialCashFlow = ({ year } = {}) => {
  const query = useQuery({
    queryKey: ["financial", "cash-flow", year],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (year != null) params.set("year", String(year));
      const qs = params.toString();
      const { data } = await axiosAPI.get(
        `/financial/cash-flow${qs ? `?${qs}` : ""}`
      );
      return data;
    },
  });

  return {
    months: query.data?.months ?? [],
    year: query.data?.year ?? year,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.error,
    refetch: query.refetch,
  };
};

export const useFinancialOverdue = () => {
  const query = useQuery({
    queryKey: ["financial", "overdue"],
    queryFn: async () => {
      const { data } = await axiosAPI.get("/financial/overdue");
      return data;
    },
  });

  return {
    overdue: query.data?.overdue ?? [],
    totals: query.data?.totals ?? {
      items_count: 0,
      clients_count: 0,
      amount_due: 0,
    },
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isError: query.error,
    refetch: query.refetch,
  };
};
